// extracted by mini-css-extract-plugin
export default {"upload-description":"RouteFeeInformation_upload-description__1MYfE"};